import { useEffect, useState } from "react";
import { getAuth, isSignInWithEmailLink } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { doCreateUserWithEmailAndPassword } from "../firebase/auth"; // ✅ Use custom function

const VerifyEmail = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const [message, setMessage] = useState("Verifying your email...");
  const [error, setError] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [showPasswordForm, setShowPasswordForm] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        if (isSignInWithEmailLink(auth, window.location.href)) {
          const email = localStorage.getItem("emailForRegistration");
          if (!email) throw new Error("Email not found. Please restart registration.");

          setMessage("Email verified! Please set a password to create your account.");
          setShowPasswordForm(true); // ✅ Show password input
        } else {
          setError("Invalid verification link.");
          navigate("/register");
        }
      } catch (error) {
        console.error("Error during email verification:", error);
        setError(error.message || "Failed to verify email.");
        navigate("/register");
      }
    };

    verifyEmail();
  }, [auth, navigate]);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      setError("Password is required.");
      return;
    }

    try {
      const email = localStorage.getItem("emailForRegistration");
      if (!email) throw new Error("Email not found. Restart registration.");

      // ✅ Create user account after email verification
      await doCreateUserWithEmailAndPassword(email, password);
      setMessage("Account created! You can now log in.");
      setIsVerified(true);
      localStorage.removeItem("emailForRegistration"); // ✅ Cleanup
    } catch (error) {
      console.error("Error creating account:", error);
      setError(error.message || "Failed to create account.");
    }
  };

  return (
    <div className="text-center p-6">
      <h1 className="text-2xl font-bold mb-4">Email Verification</h1>
      {error ? (
        <div className="text-red-600 mb-4">{error}</div>
      ) : (
        <div className="text-green-600 mb-4">{message}</div>
      )}

      {showPasswordForm && !isVerified && (
        <form onSubmit={handlePasswordSubmit} className="max-w-md mx-auto">
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1 text-gray-700">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
              placeholder="Enter your password"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-all duration-300"
          >
            Create Account
          </button>
        </form>
      )}

      {isVerified && (
        <button
          onClick={() => navigate("/auth")}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-all duration-300"
        >
          Go to Login Page
        </button>
      )}
    </div>
  );
};

export default VerifyEmail;
